import React, { useEffect, useState, useContext } from 'react'
import DoctorService from '../../../../../../services/api/doctor.service'
import Utilities from '../../../../../../services/commonservice/utilities'
import ModalBox from '../../../../../templates/components/ModalBox'
import { store } from '../../../../../../context/StateProvider'

// Common service
import Table2 from '../../../../../templates/components/Table2'
import EditDoctor from '../../../doctor/edit-doctor/EditDoctor'
import PracticeLocationSelector from '../../../../../templates/components/PracticeLocationSelector'
import AddDoctor from '../../../doctor/add-doctor/AddDoctor'
import ProviderDetails from './provider-details/ProviderDetails'
import ProviderServices from '../provider-services/ProviderServices'
import DimLoader from '../../../../../templates/components/DimLoader'
import APIResponse from '../../../../../templates/components/APIResponse'

const ProviderTableSettings = (props) => {
    const { keyword } = props
    // Temp var holders
    const [isLoader, setIsLoader] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    //const [deleteModal, setDeleteModal] = useState(false)
    const [showAdd, setShowAdd] = useState(false)
    const [showEdit, setShowEdit] = useState(false)
    const [showDetails, setShowDetails] = useState(false)
    const [showServices, setShowServices] = useState(false)
    const [providerList, setProviderList] = useState([])
    const [selectedProvider, setSelectedProvider] = useState()
    const [activateModal, setActivateModal] = useState(false)
    const hiddenColumns = ["email", "mobile", "npi"]
    const [apiResponse,setApiResponse] = useState()
    const globalStateAndDispatch = useContext(store)
    const state = globalStateAndDispatch.state
    const dispatch = globalStateAndDispatch.dispatch
    const [locationId, setLocationId] = useState(state.practiceLocationId || null);
    const onSuccess = (message) => {
        setProviderList([])
        getProviders()
        dispatch({
            type: "setLocationProviderServices",
            payload: null
        });
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.onClose) {
            props.onClose()
        }
    }

    const activateProvider = (id, provider) => {
        setIsLoading(true);
        if (provider?.isActiveDoctor) {
            DoctorService.deactivatePractitioner(id)
            .then(response => {
                setApiResponse(response)
            })
            .catch(error => {
                setApiResponse(error)
            })
            .finally(() => {
                setIsLoading(false)
            });
        }
        else {
            DoctorService.activatePractitioner(id)
            .then(response => {
                setApiResponse(response)
            })
            .catch(error => {
                setApiResponse(error)
            })
            .finally(() => {
                setIsLoading(false)
            });
        }
    }

    // const deleteItem = (id) => {
    //     setIsLoading(true)
    //     DoctorService.delete(id).then(response => {
    //         setApiResponse(response)
    //     })
    //     .catch(error => {
    //         setApiResponse(error)
    //     })
    //     .finally(() => {
    //         setActivateModal(false)
    //         setIsLoading(false)
    //     });
    // }
    const getProviders = () => {
        setIsLoader(true);
        DoctorService.doctorLookup({ isRegistered: true, PracticeLocationId: locationId || null })
            .then((response) => {
                console.log(response)
                // setProviderList(response.map(res => {
                //     return { ...res, subData: <ProviderDetails providerId={res.id} /> }
                // }));
                setProviderList(response)
                setIsLoader(false);
            })
            .catch(error => {
                setIsLoader(false);
            })
    }
    useEffect(() => {
        //if (locationId) {
            getProviders()
        //}
    }, [locationId])

    const onLocationChanged = (newLocationId) => {
        setLocationId(newLocationId)
    }

    const columns = [
        {
            id: "firstName",
            Header: "First Name",
            accessor: provider => provider.firstName
        },
        {
            id: "lastName",
            Header: "Last Name",
            accessor: provider => provider.lastName
        },
        {
            id: "email",
            Header: "Email",
            accessor: provider => provider.email
        },
        {
            id: "mobile",
            Header: "Mobile Number",
            accessor: (provider) => Utilities.toPhoneNumber(provider.mobile)
        },
        {
            id: "npi",
            Header: "NPI",
            accessor: provider => provider.npi
        },
        {
            id: "status",
            Header: "Status",
            // className: "name",
            align: "center",
            sortable: true,
            accessor: (provider) => provider.isActiveDoctor ? <span className='btn btn-success text-white w-100'>Active</span> : <span className='btn btn-danger text-white w-100'>Inactive</span>
        },
        {
            id: "actionProvider",
            Header: "Action",
            textAlign: 'center',
            disableSortBy: true,
            accessor: (provider) => {
                //console.log(provider)
                return (
                    <div className='btn-group'>
                        <button className="p-0 ps-1 btn btn-primary ms-1" title="Edit Provider" onClick={e => {
                            e.preventDefault();
                            setSelectedProvider(provider);
                            setShowEdit(true);
                            return;
                        }}><i className="icon pencil" /></button>

                        <button className="p-0 ps-1 btn btn-primary ms-1" title="Availability" onClick={e => {
                            e.preventDefault();
                            setSelectedProvider(provider);
                            setShowDetails(true);
                            return;
                        }}><i className="icon clock" /></button>

                        <button className="p-0 ps-1 btn btn-primary ms-1" title="Services" onClick={e => {
                            e.preventDefault();
                            setSelectedProvider(provider);
                            setShowServices(true);
                            return;
                        }}><i className="icon stethoscope" /></button>

                        <button className="p-0 ps-1 btn btn-primary ms-1" title={provider.isActiveDoctor ? 'Deactivate User' : 'Activate User'} onClick={e => {
                            e.preventDefault();
                            setSelectedProvider(provider);
                            return setActivateModal(true)
                        }}>{provider.isActiveDoctor ? <i className="icon dont" /> : <i className="icon check" />}</button>
                    </div>
                )
            }
        }
    ]

    return (
        <>
         {isLoading && <DimLoader />}
            <Table2 hiddenColumns={hiddenColumns} export searchable columns={columns} data={providerList} loading={isLoader}
                extraButtons={[
                    { className: 'btn btn-primary', children: <i className='icon plus' />, onClick: () => { setShowAdd(true) }, title: "Add Provider" }
                ]}
                extraElements={[
                    { children: <div style={{ width: '300px' }}><label>Select Practice Location</label><PracticeLocationSelector placeholder={"All Provider – includes 'Not Linked'"} isClearable={true} onSelected={onLocationChanged} dontResetState={true} /></div> },
                ]} />
            {/* <ModalBox open={deleteModal} onClose={() => { setDeleteModal(false) }} title="Delete Modal">
                <div className='row d-flex align-items-center justify-content-between'>
                    <div className='col-md-auto col-12'>
                        Are you sure you want to delete {selectedProvider?.name}?
                    </div>
                    <div className='col-md-auto col-12'>
                        <div className='row d-flex justify-content-between modal-button-bar'>
                            <div className='col-auto'>
                                <button className='btn btn-secondary ms-3 m-m-0' onClick={e => { e.preventDefault(); setSelectedProvider(); return setDeleteModal(false) }}>No</button>
                            </div>
                            <div className='col-auto'>
                                <button className='btn btn-primary' onClick={e => { e.preventDefault(); deleteItem(selectedProvider?.id) }}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalBox> */}
            <ModalBox open={activateModal} onClose={() => { setActivateModal(false) }} title={selectedProvider?.isActiveDoctor ? 'Deactivate Provider' : 'Activate Provider'}>
                <div className='row d-flex align-items-center justify-content-between remove-gutter'>
                    <div className='col-md-auto col-12 py-3'>
                        Are you sure you want to {selectedProvider?.isActiveDoctor ? 'Deactivate' : 'Activate'} {selectedProvider?.name}?
                    </div>
                    <div className='col-md-auto col-12'>
                        <div className='row d-flex justify-content-between modal-button-bar remove-gutter'>
                            <div className='col-auto'>
                                <button className='btn btn-primary' onClick={e => { e.preventDefault();setActivateModal(false); activateProvider(selectedProvider?.id, selectedProvider) }}>Yes</button>
                            </div>
                            <div className='col-auto'>
                                <button className='btn btn-secondary ms-3 m-m-0' onClick={e => { e.preventDefault(); setSelectedProvider(); return setActivateModal(false) }}>No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalBox>
            <ModalBox open={showAdd} onClose={() => { setShowAdd(false) }} title="Add Provider">
                <AddDoctor onClose={() => { setShowAdd(false); }} 
                    refresh={() => {
                        setProviderList([])
                        getProviders()
                    }}/>
            </ModalBox>
            <ModalBox open={showEdit} onClose={() => { setShowEdit(false) }} title="Edit Provider">
                <EditDoctor id={selectedProvider?.id} onClose={() => { setShowEdit(false); }} 
                    refresh={() => {
                        setProviderList([])
                        getProviders()
                    }}/>
            </ModalBox>
            <ModalBox open={showDetails} onClose={() => { setShowDetails(false) }} title="Provider Details">
                <ProviderDetails provider={selectedProvider} onClose={() => { setShowDetails(false); }} 
                    refresh={() => {
                        getProviders()
                    }}/>
            </ModalBox>
            <ModalBox open={showServices} onClose={() => { setShowServices(false) }} title="Provider Services" size="large">
                <ProviderServices provider={selectedProvider} onClose={() => { setShowServices(false); }} />
            </ModalBox>
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>
    )
}

export default ProviderTableSettings